import * as React from 'react';

const ExclamationIcon = ({ color = '#98A2B3' }) => (
  <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.5 0C25.3125 0 32.5 7.1875 32.5 16C32.5 24.875 25.3125 32 16.5 32C7.625 32 0.5 24.875 0.5 16C0.5 7.1875 7.625 0 16.5 0ZM16.5 30C24.1875 30 30.5 23.75 30.5 16C30.5 8.3125 24.1875 2 16.5 2C8.75 2 2.5 8.3125 2.5 16C2.5 23.75 8.75 30 16.5 30ZM16.5 19C15.9375 19 15.5 18.5625 15.5 18V8C15.5 7.5 15.9375 7 16.5 7C17 7 17.5 7.5 17.5 8V18C17.5 18.5625 17 19 16.5 19ZM16.5 21.5C17.3125 21.5 18 22.1875 18 23C18 23.875 17.3125 24.5 16.5 24.5C15.625 24.5 15 23.875 15 23C15 22.1875 15.625 21.5 16.5 21.5Z"
      fill={color}
    />
  </svg>
);
export default ExclamationIcon;
